module.exports = __webpack_public_path__ + "img/appstore-w.04e03d10.svg";